// Utils: chunkErrorHandler
// Purpose: Detect and recover from Vite chunk loading errors (e.g., HTML served
// as JS) by clearing relevant caches and reloading. Also installs global
// listeners for unhandledrejection and error.

let isHandlingChunkError = false;

export const handleChunkError = (error) => {
  console.error('Chunk loading error detected:', error);
  
  // Prevent infinite reload loops
  if (isHandlingChunkError) {
    console.warn('Already handling chunk error, skipping reload');
    return;
  }
  
  // Check if this is a chunk loading error
  const isChunkError = 
    error.message?.includes('Loading chunk') ||
    error.message?.includes('ChunkLoadError') ||
    error.message?.includes('Unexpected token') ||
    (error.stack && error.stack.includes('Unexpected token')) ||
    (typeof error === 'string' && error.includes('Unexpected token'));
  
  if (isChunkError) {
    console.log('Chunk loading error detected, attempting recovery...');
    isHandlingChunkError = true;
    
    // Clear any problematic caches
    if ('caches' in window) {
      caches.keys().then(cacheNames => {
        cacheNames.forEach(cacheName => {
          if (cacheName.includes('vite') || cacheName.includes('assets')) {
            caches.delete(cacheName);
          }
        });
      }).catch(err => console.warn('Cache clearing failed:', err));
    }
    
    // Reload the page after a short delay
    setTimeout(() => {
      console.log('Reloading page to recover from chunk error...');
      window.location.reload();
    }, 100);
    
    return true; // Indicates error was handled
  }
  
  return false; // Not a chunk error
};

// Global error handler for unhandled promise rejections (common with chunk loading)
export const setupGlobalChunkErrorHandling = () => {
  // Handle unhandled promise rejections
  window.addEventListener('unhandledrejection', (event) => {
    if (handleChunkError(event.reason)) {
      event.preventDefault(); // Prevent the error from being logged to console
    }
  });
  
  // Handle regular errors
  window.addEventListener('error', (event) => {
    if (handleChunkError(event.error)) {
      event.preventDefault();
    }
  });
  
  console.log('Global chunk error handling setup complete');
}; 